// extracted by mini-css-extract-plugin
export var layoutContainer = "_di-0";
export var layoutContainerNoRounding = "_di-6";
export var layoutContainerOpen = "_di-5";
export var layoutContainerResizing = "_di-1";
export var mainContent = "_di-2";
export var resizeDivider = "_di-3";
export var slidePanel = "_di-4";